const map = {
	"./Mobile.png": 748,
	"./campuslm1.png": 699,
	"./mooslix1.png": 412,
	"./nikolaslarson1.png": 527,
	"./nourished1.png": 266,
	"./tarragon1.png": 447,
	"./tarragon2.png": 164,
	"./tarragon3.png": 229
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 125;